module.exports = __webpack_public_path__ + "static/media/rings.986af371.jpg";